"use client";

import { OverlayView } from "@react-google-maps/api";
import {
	createAccentPinMarkerHtml,
	getAccentPinDimensions,
	type MapIconAsset,
} from "@/lib/map-config";
import styles from "./index.module.scss";

type GoogleAccentPinMarkerProps = {
	position: { lat: number; lng: number };
	mapIcon?: MapIconAsset | null;
	accentColor?: string;
	onClick?: () => void;
};

export function GoogleAccentPinMarker({
	position,
	mapIcon,
	accentColor,
	onClick,
}: GoogleAccentPinMarkerProps) {
	const { width, height } = getAccentPinDimensions(mapIcon);

	return (
		<OverlayView
			position={position}
			mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
			getPixelPositionOffset={() => ({
				x: -(width / 2),
				y: -height,
			})}
		>
			<button
				type="button"
				className={styles.pin}
				onClick={onClick}
				aria-label="Toggle navigation options"
				dangerouslySetInnerHTML={{
					__html: createAccentPinMarkerHtml(mapIcon, accentColor),
				}}
			/>
		</OverlayView>
	);
}
